import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import AirFreight from './AirFreight';
import CustomBrokrage from './CustomBrokrage';
import RoadFreight from './RoadFreight';
import SeaFreight from './SeaFreight';


const InternationalFreights = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
    return(
        <div>
            <div id='international' className="international-freight-image">
                <img src='/international-freight/Logistics-Main-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px] pb-[1rem]">
                <p>
                    TCS provides seamless regional and global connectivity through its vast global network. 
                    With international gateways in Karachi and Islamabad, our regional hub in the UAE and growing 
                    partnerships in Central Asia and the world, we are focused on enabling and enhancing trade and 
                    commerce for ‘Made in Pakistan’ as the logistics backbone of our economy.
                </p>
                <p>
                    With certified standards and trained resources, TCS is an ISO 9001, ISO 9002, DGR, ADR, IATA, 
                    PIFFA, FIATA and ACAAP certified organisation. From getting a shipment ready, and handling customs, 
                    to tracking, monitoring and buyer consolidation, we know exactly how to manage your international 
                    freight requirements.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/international-freights/air-freight"  className='font-bold'>Air Freight</Link></li>
                            </div>
                            
                            <div className="flex items-center">
                                <li><Link to="/international-freights/road-freight" className='font-bold'>Overland Freight</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">

                        <div className="flex items-center">
                                <li><Link to="/international-freights/sea-freight" className='font-bold'>Ocean Freight</Link></li>
                            </div>
                            
                            <div className="flex items-center">
                                <li><Link to="/international-freights/custom-brokrage" className='font-bold'>Customs House Brokerage</Link></li>
                            </div>
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[2rem]'>
            <div id="air-freight">
                <AirFreight/>
            </div>
            <div id="sea-freight">
                <SeaFreight/>
            </div>
            <div id="road-freight">
                <RoadFreight/>
            </div>
            <div id="custom-brokrage">
                <CustomBrokrage/>
            </div>
            </div>
        </div>


    )
};
export default InternationalFreights;